import type { DataTableColumn } from '../common/DataTable';
import type { LeaderboardItem } from '../../services/graphApi';

export function createLeaderboardColumns(): DataTableColumn<LeaderboardItem>[] {
  return [
    { key: 'rank', header: '등수', sortable: true, width: 80 },
    { key: 'bibNumber', header: '배번호', sortable: true, width: 100 },
    { key: 'name', header: '이름', sortable: true },
    { key: 'category', header: '종목', sortable: true },
    { key: 'gender', header: '성별', sortable: true, width: 90 },
    {
      key: 'chiptimeElapsedTime',
      header: '기록 시간',
      sortable: true,
      align: 'right',
      width: 140,
    },
    { key: 'gap', header: '1등과의 차이', sortable: true, align: 'right', width: 150 },
  ];
}
